import { render } from "./IoWarehouse.vue?vue&type=template&id=b4179064&scoped=true"
import script from "./IoWarehouse.vue?vue&type=script&lang=js"
export * from "./IoWarehouse.vue?vue&type=script&lang=js"

import "./IoWarehouse.vue?vue&type=style&index=0&id=b4179064&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4179064"

export default script